var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHourGlass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 26,
    viewBox: "0 0 20 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3563 3.04532H1.37264C0.800558 3.04532 0.299988 2.58051 0.299988 1.97267C0.299988 1.36484 0.764803 0.900024 1.37264 0.900024H18.392C18.9641 0.900024 19.4647 1.36484 19.4647 1.97267C19.4647 2.58051 18.9641 3.04532 18.3563 3.04532Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.9539 14.5227C9.73937 14.5227 9.52484 14.4512 9.38182 14.3439L5.6633 11.8768C3.8398 10.6611 2.76715 8.65886 2.76715 6.4778V1.97267C2.76715 1.40059 3.23197 0.900024 3.8398 0.900024C4.41188 0.900024 4.91245 1.36484 4.91245 1.97267V6.4778C4.91245 7.94376 5.62755 9.30245 6.87897 10.1248L9.98966 12.1986L13.1003 10.1248C14.316 9.30245 15.0669 7.94376 15.0669 6.4778V1.97267C15.0669 1.40059 15.5317 0.900024 16.1395 0.900024C16.7116 0.900024 17.2122 1.36484 17.2122 1.97267V6.4778C17.2122 8.65886 16.1395 10.6969 14.316 11.8768L10.5617 14.3439C10.383 14.4512 10.1684 14.5227 9.9539 14.5227Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3563 26H1.37264C0.800558 26 0.299988 25.5352 0.299988 24.9274C0.299988 24.3553 0.764803 23.8547 1.37264 23.8547H18.392C18.9641 23.8547 19.4647 24.3196 19.4647 24.9274C19.4289 25.5352 18.9641 26 18.3563 26Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1037 26C15.5316 26 15.031 25.5352 15.031 24.9274V20.4223C15.031 18.9563 14.3159 17.5976 13.0645 16.7752L9.95383 14.7015L6.84315 16.7752C5.62748 17.5976 4.87662 18.9563 4.87662 20.4223V24.9274C4.87662 25.4995 4.41181 26 3.80397 26C3.23189 26 2.73132 25.5352 2.73132 24.9274V20.4223C2.73132 18.2412 3.80397 16.2032 5.62748 15.0233L9.34599 12.5562C9.70354 12.3059 10.1684 12.3059 10.5259 12.5562L14.2444 15.0233C16.0679 16.2389 17.1406 18.2412 17.1406 20.4223V24.9274C17.1406 25.5352 16.6758 26 16.1037 26Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHourGlass);
export default __webpack_public_path__ + "static/media/hourGlass.fd2898b2.svg";
export { ForwardRef as ReactComponent };